import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import Heading from "components/Typography/Header";
import Button from "components/Button";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { createSubreseller, reset,getResellers } from "redux/admin/users/usersSlice";

const CreateSubresellersContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const {
    isSuccessCreateSubreseller,
    isErrorCreateSubreseller,
    isLoadingCreateReseller,
    messageSubresellers,
    resellers
  } = useSelector((state) => state.adminUsers);

  const createSubresellerForm = Yup.object().shape({
    phone: Yup.string().required("Telefon numarası gereklidir."),
    name: Yup.string().required("Ad gereklidir."),
    reseller_id: Yup.string().required("Bayi gereklidir."),
    balance_diamonds: Yup.string().required("Elmas bakiye gereklidir."),
  });

  useEffect(() => {
    dispatch(getResellers());
  }, []);

  useEffect(() => {
    if (isErrorCreateSubreseller) {
      toast.error(messageSubresellers);
    }
    if (isSuccessCreateSubreseller) {
      toast.success("Alt Bayi başarıyla oluşturuldu.");
      setTimeout(() => {
        navigate("/admin/subresellers");
      }, 1500);
    }
    return () => {
      dispatch(reset());
    };
  }, [
    isSuccessCreateSubreseller,
    isErrorCreateSubreseller,
    messageSubresellers,
    dispatch,
  ]);

  return (
    <div className="p-4 ">
      <Heading className="text-white-100" level={5}>
        Alt Bayi Ekle
      </Heading>
      <div className="p-4 bg-gray-900 my-4 rounded-xl min-h-screen">
        <div className="gap-4">
          <div className="p-4 bg-black md:h-screen">
            <Formik
              initialValues={{
                phone: "",
                name: "",
                reseller_id:"",
                balance_diamonds: "",
              }}
              validationSchema={createSubresellerForm}
              onSubmit={(values) => {
                dispatch(createSubreseller({
                    phone: values.phone,
                    name: values.name,
                    balance_diamonds: values.balance_diamonds,
                    reseller_id:values.reseller_id,
                }));
              }}
            >
              {({ errors, touched, setFieldValue, values }) => {
                return (
                  <Form className="space-y-4 max-w-[500px]">
                    <div className="">
                      <span className="text-white-100 font-medium">
                        Alt Bayi Adı
                      </span>
                      <Field
                        name="name"
                        type="text"
                        className="w-full font-medium bg-white-100 rounded-lg appearance-none focus:outline-none  p-2 mt-2"
                      />
                      <ErrorMessage
                        name="name"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="">
                      <span className="text-white-100 font-medium">
                        Telefon Numarası
                      </span>
                      <Field
                        name="phone"
                        type="text"
                        className="w-full font-medium bg-white-100 rounded-lg appearance-none focus:outline-none  p-2 mt-2"
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="">
                      <span className="text-white-100 font-medium">
                        Bakiye (Elmas)
                      </span>
                      <Field
                        name="balance_diamonds"
                        type="number"
                        className="w-full font-medium bg-white-100 rounded-lg appearance-none focus:outline-none  p-2 mt-2"
                      />
                      <ErrorMessage
                        name="balance_diamonds"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <div className="">
                      <span className="text-white-100 font-medium">
                        Bayi Seçin
                      </span>
                      <Field
                        name="reseller_id"
                        as="select"
                        className="w-full font-medium bg-white-100 rounded-lg appearance-none focus:outline-none  p-2 mt-2"
                      >
                        <option value="">Bayi Seçin</option>
                        {resellers.data?.map((reseller) => (
                          <option value={reseller.id}>{reseller.name}</option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="balance_diamonds"
                        component="div"
                        className="text-red-500"
                      />
                    </div>
                    <Button
                      type="submit"
                      size="small"
                      loading={isLoadingCreateReseller}
                      className="bg-primary"
                    >
                      Alt Bayi Oluştur
                    </Button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateSubresellersContainer;
